export default {
  confirmDelete: 'Czy chcesz Usunąć "{0}"?',
  emptyMessage: 'Brak dostępnych {0}.',
  uploadButtonLabel: 'Prześlij {0}',
  files: 'akta',
};
